module.exports = __webpack_public_path__ + "img/wlc.911fc33d.jpg";